/** Settings → Languages. Conventions: see `common.ts`. */
const languages: Record<string, string> = {
  title: 'Languages',
  description: 'Choose the languages your storefront is published in and the language of this dashboard.',

  'store.title': 'Storefront languages',
  'store.description':
    'Shoppers can switch between these languages. They appear in the switcher in this order.',
  'store.add': 'Add language',
  'store.add_placeholder': 'Search languages',
  'store.none_available': 'Every available language is already enabled.',
  'store.enable': 'Enable',
  'store.disable': 'Disable',
  'store.enabled': 'Enabled',
  'store.disabled': 'Disabled',
  'store.remove': 'Remove',
  'store.remove_confirm_title': 'Remove {language}?',
  'store.remove_confirm_body':
    'Shoppers will no longer see your store in {language}. Its translations are kept and come back if you enable it again.',
  'store.reorder': 'Drag to reorder',
  'store.move_up': 'Move up',
  'store.move_down': 'Move down',
  'store.count_one': '{count} language enabled',
  'store.count_other': '{count} languages enabled',

  'default.label': 'Default',
  'default.title': 'Default language',
  'default.make': 'Make default',
  'default.hint':
    'Shoppers see the default language when nothing else decides. Your existing content is written in it.',
  'default.change_title': 'Change the default language to {language}?',
  'default.change_body':
    'Your current content will be kept as the {from} translation, and the {to} translation becomes the main content. Nothing is lost.',
  'default.cannot_disable': 'The default language cannot be disabled.',

  'admin.title': 'Dashboard language',
  'admin.hint': 'The language of this dashboard for your whole team, unless someone chooses their own.',
  'admin.use_default': 'English (default)',
  'mine.title': 'My dashboard language',
  'mine.hint': 'Applies only to you and overrides the store setting.',
  'mine.use_store': 'Use the store setting ({language})',
  'mine.saved': 'Your dashboard language has been updated.',

  'options.title': 'Storefront behaviour',
  'options.fallback': 'Show the default language when a translation is missing',
  'options.fallback_hint':
    'When off, products, pages and posts that are not translated are hidden in that language.',
  'options.switcher': 'Show the language switcher',
  'options.switcher_hint': 'Lets shoppers change the language from your storefront.',
  'options.detect': "Detect the shopper's browser language",
  'options.detect_hint':
    "Opens the storefront in the language of the shopper's browser when you have enabled it.",

  'plan.usage': '{used} of {limit} languages used',
  'plan.unlimited': 'Unlimited languages',
  'plan.limit_reached': 'Your plan allows {limit} languages. Upgrade to add more.',
  'plan.upgrade': 'Upgrade plan',

  'meta.name': 'Language',
  'meta.native_name': 'Native name',
  'meta.code': 'Code',
  'meta.locale': 'Locale',
  'meta.direction': 'Direction',
  'meta.ltr': 'Left to right',
  'meta.rtl': 'Right to left',

  'translations.link': 'Manage translations',
  'translations.progress': '{percent}% translated',

  saved: 'Language settings saved.',
  save: 'Save language settings',

  'errors.NO_LANGUAGES_ENABLED': 'Enable at least one language.',
  'errors.DEFAULT_LANGUAGE_NOT_ENABLED': 'The default language must be one of the enabled languages.',
  'errors.LANGUAGE_NOT_AVAILABLE': 'That language is not available.',
  'errors.LANGUAGE_NOT_ENABLED': 'That language is not enabled for your store.',
  'errors.PLAN_LIMIT_REACHED': 'Your plan does not allow more languages. Upgrade to add more.',
  'errors.LANGUAGE_SETTINGS_CONFLICT': 'Someone else changed these settings at the same time. Reload and try again.',
  'errors.load_failed': 'We could not load your language settings.',
  'errors.save_failed': 'We could not save your language settings.',

  'page.read_only': 'You have read-only access to store settings, so you can view these languages but not change them.',
  'page.reorder_hint':
    "Use the arrow buttons to change the order, or focus a language's handle and press the up and down arrow keys.",
  'page.reorder_named': 'Reorder {language}',
  'page.move_up_named': 'Move {language} up',
  'page.move_down_named': 'Move {language} down',
  'page.remove_named': 'Remove {language}',
  'page.moved': '{language} moved to position {position}.',
  'page.add_select': 'Language to add',
  'page.choose_language': 'Choose a language',

  'settings_card.description':
    'Publish your storefront in more than one language, and choose the language of this dashboard.',
  'settings_card.link': 'Manage languages →',
};

export default languages;
